import { ProcedureTypeFieldsService as OvermapProcedureTypeFieldsService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureTypeFieldsService extends OvermapProcedureTypeFieldsService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
